import React from 'react';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';

const getSrc = ({ source, video }) => {
  if (source === 'taggle') {
    return `https://taggleauto.movieplayer.nl/${video}`;
  }
  if (source === 'youtube') {
    return `https://www.youtube.com/embed/${video}?fs=1&rel=0`;
  }
  return null;
};

const Video = ({ source, video, title = null }) => {
  const src = getSrc({ source, video });
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: '150px',
    triggerOnce: true,
  });

  if (!src) {
    return null;
  }

  return (
    <Wrapper ref={ref}>
      {inView && (
        <Iframe
          title={title || video}
          src={src}
          frameborder="0"
          allowfullscreen
        />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
`;

const Iframe = styled.iframe`
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export default styled(Video)``;
